import React from "react";
// Components
import Table from "../../../../components/Table/Table";
import { __ } from "@wordpress/i18n";
import { QuoteEquityScenarios } from "../Result/QuoteEquity";

// TEMPORARY: dumps every field the API returns, see resultRows.ts.
import { flattenResultRows } from "../resultRows";

/** Constants for reusable values */
const CLASSES = {
  TEXT_LEFT: "text-left",
};

/** Strings with i18n */
const LABELS = {
  headers: {
    empty: " ",
    prudente: __("Cenário prudente", "df-simulators"),
    ampliado: __("Cenário ampliado", "df-simulators"),
  },
};

interface TabComparisonProps {
  scenarios: QuoteEquityScenarios;
}

/**
 * Component
 *
 * Flattens both scenarios independently and zips them by row order —
 * relies on prudente/ampliado sharing the same shape (true today, since
 * both come from the same property/region), rather than matching by
 * label, since the field set isn't confirmed yet. Revisit once it is.
 */
const TabComparison: React.FC<TabComparisonProps> = ({ scenarios }) => {
  const prudenteRows = flattenResultRows(
    scenarios.prudente as unknown as Record<string, any>,
  );
  const ampliadoRows = flattenResultRows(
    scenarios.ampliado as unknown as Record<string, any>,
  );

  const headers = [
    { value: LABELS.headers.empty, className: CLASSES.TEXT_LEFT },
    { value: LABELS.headers.prudente, className: CLASSES.TEXT_LEFT },
    { value: LABELS.headers.ampliado, className: CLASSES.TEXT_LEFT },
  ];

  const data = prudenteRows.map((row, index) => [
    { value: row.label, className: CLASSES.TEXT_LEFT },
    { value: row.value, className: CLASSES.TEXT_LEFT },
    { value: ampliadoRows[index]?.value ?? "", className: CLASSES.TEXT_LEFT },
  ]);

  return (
    <Table
      headers={headers}
      data={data}
      noMobile={undefined}
      firstRow={undefined}
      loadMoreBtn={undefined}
      hasMoreRows={undefined}
      onLoadMore={undefined}
    />
  );
};

export default TabComparison;
